import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { FaBars } from "react-icons/fa";
import { db } from "./Firebase";

export default function Distributorship() {

    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [selectedEnquiry, setSelectedEnquiry] = useState(null);


    const [data, setdata] = useState([]);

    function fetchdata() {
        db.collection("mainform").onSnapshot((succ) => {
            const sortedData = succ.docs.sort((a, b) => {
                const dateA = new Date(a.data().Date);
                const dateB = new Date(b.data().Date);

                return dateB - dateA; // Latest date first
            });

            setdata(sortedData);
        });
    }

    useEffect(() => {
        fetchdata();
    }, [])

    return (
        <>
            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    {/* Main Content */}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 offset-0 offset-lg-0 offset-md-0 ps-2">

                        <div className="container-fluid my-1">
                            <div className="mb-4 px-3 ms-2 ps-5 mt-2">
                                <div className="card shadow-sm rounded p-1">
                                    <h4 className="mt-2 ms-2">Distributorship Requests</h4>
                                    <p className="text-muted ms-2">Manage dealership applications and approvals</p>
                                </div>
                            </div>
                            <div className="px-3 ms-2 ps-5 mt-2">
                                <div className="table-responsive shadow-sm rounded">
                                    <table className="table table-bordered align-middle mb-0">
                                        <thead className="table-primary">
                                            <tr>
                                                <th>Business Name</th>
                                                <th>Owner Name</th>
                                                <th>Contact</th>
                                                <th>Enquiry Type</th>

                                                <th>Location</th>
                                                <th>Date Applied</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data
                                                .filter((row) => row.data().Enquirytype?.toLowerCase() === "distributor")
                                                .map((row) => (
                                                    <tr key={row.id}>
                                                        <td>{row.data().Businessname}</td>
                                                        <td>{row.data().Name}</td>
                                                        <td>{row.data().Number}</td>
                                                        <td>{row.data().Enquirytype}</td>

                                                        <td>{row.data().Citystate}</td>
                                                        <td>{row.data().Date}</td>
                                                        <td>
                                                            <select className={`form-select w-75 ${row.data().Status === "Pending"
                                                                ? "bg-info text-light"
                                                                : row.data().Status === "Contacted"
                                                                    ? "bg-primary text-light"
                                                                    : row.data().Status === "Converted"
                                                                        ? "bg-success text-light"
                                                                        : row.data().Status === "Rejected"
                                                                            ? "bg-danger text-light"
                                                                            : "bg-secondary"
                                                                }`}
                                                                value={row.data().Status}
                                                                onChange={(e) =>
                                                                    db.collection("mainform").doc(row.id).update({
                                                                        Status: e.target.value,
                                                                    })
                                                                }>
                                                                <option value="Pending">Pending</option>
                                                                <option value="Contacted">Contacted</option>
                                                                <option value="Converted">Converted</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <button className="btn btn-link p-0 text-primary me-2" data-bs-toggle="modal" data-bs-target="#mymod" onClick={() => setSelectedEnquiry(row)}>
                                                                View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="mymod" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Distributorship</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                {selectedEnquiry && (
                                    <>
                                        <div className="row">
                                            <div className="col-lg-6 col-12">
                                                <p><strong>Name:</strong> {selectedEnquiry.data().Name}</p>
                                                <p><strong>Email:</strong> {selectedEnquiry.data().Email}</p>
                                                <p><strong>Location:</strong> {selectedEnquiry.data().Citystate}</p>
                                                <p><strong>Status:</strong> {selectedEnquiry.data().Status}</p>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <p><strong>Business Name:</strong> {selectedEnquiry.data().Businessname}</p>
                                                <p><strong>Business Type:</strong> {selectedEnquiry.data().Businesstype}</p>
                                                <p><strong>Phone:</strong> {selectedEnquiry.data().Number}</p>
                                                <p><strong>Date:</strong> {selectedEnquiry.data().Date}</p>
                                            </div>
                                        </div>
                                        <p><strong>Message:</strong> {selectedEnquiry.data().Message}</p>
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}